module.exports = __webpack_public_path__ + "img/icon_shuomingshu@2x.8cceb9f1.png";